import { render, staticRenderFns } from "./XInputTextField.vue?vue&type=template&id=4e8aca8c&"
import script from "./XInputTextField.vue?vue&type=script&lang=ts&"
export * from "./XInputTextField.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports